import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useContextMotifDetails } from '../contexts/motifDetailsContext'

const MotifDetailsCardHandler = () => {
  const { id } = useParams<{ id: string }>()
  const { setTargetedMotif, setDetailsOpen, allMotifs } = useContextMotifDetails()

  useEffect(() => {
    console.log('CARD HANDLER', { id, allMotifsLength: allMotifs.length })

    if (!id || !allMotifs.length) return

    const numericId = parseInt(id.split(/[_\-\s]/)[0], 10)
    console.log('CARD HANDLER parsed', { numericId })
    if (isNaN(numericId)) return

    const motif = allMotifs.find(m => m.id === numericId)
    if (!motif) return

    console.log('CARD HANDLER motif', motif)
    setTargetedMotif(motif.id)
    setDetailsOpen(true)
  }, [id, allMotifs, setTargetedMotif, setDetailsOpen])

  return null
}

export default MotifDetailsCardHandler
